














import { Component, Prop, Vue } from "vue-property-decorator";
import EmptyDialogComponent from "@/components/common/parts/EmptyDialogComponent.vue";

@Component({
  components: {
    EmptyDialogComponent
  }
})
export default class ConfirmDialogComponent extends Vue {
  @Prop({
    default: false
  })
  public display!: boolean;

  @Prop({
    default: "変更内容を破棄しますか？"
  })
  public title!: string;

  @Prop({
    default: "編集したデータは保存されていません"
  })
  public body!: string;
}
